module.exports = __webpack_public_path__ + "img/computer.6eff5baf.png";